import { render, staticRenderFns } from "./ShelfTabComponent.vue?vue&type=template&id=0f5a809c&scoped=true&"
import script from "./ShelfTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ShelfTabComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a809c",
  null
  
)

export default component.exports